import * as types from "../actions/actionTypes";

// state = [] : Start out with no accounts
export default function resourceCategories(state = [], action) {
  switch (action.type) {
    case types.GET_RESOURCE_CATEGORIES:
      return action.resource_categories;

    case types.CREATE_RESOURCE_CATEGORY:
      return [...state, Object.assign({}, action.resource_category)];

    default:
      return state;
  }
}
